import { ThunkApiType } from 'types/storeTypes';
import authFetch, { checkForUnauthorizedResponse } from 'utils/axios';

export const getBannersThunk = async (_: string, thunkAPI: ThunkApiType) => {
	let getBannersURL = '/provider/banners';

	try {
		const response = await authFetch.get(getBannersURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const setBannersThunk = async (
	externalProviderMasterId: string,
	thunkAPI: ThunkApiType,
) => {
	let setBannersURL = '/provider/profile/banners';

	try {
		const response = await authFetch.put(setBannersURL, {
			externalProviderMasterId: externalProviderMasterId,
		});

		if (response.status === 200) {
			window.location.reload();
		}

		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};
